/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BankAccountDetails } from './BankAccountDetails';
import {
    BankAccountDetailsFromJSON,
    BankAccountDetailsFromJSONTyped,
    BankAccountDetailsToJSON,
} from './BankAccountDetails';

/**
 * 
 * @export
 * @interface ClientBankAccountsViewModel
 */
export interface ClientBankAccountsViewModel {
    /**
     * 
     * @type {Array<BankAccountDetails>}
     * @memberof ClientBankAccountsViewModel
     */
    bankAccountsList: Array<BankAccountDetails>;
}

/**
 * Check if a given object implements the ClientBankAccountsViewModel interface.
 */
export function instanceOfClientBankAccountsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bankAccountsList" in value;

    return isInstance;
}

export function ClientBankAccountsViewModelFromJSON(json: any): ClientBankAccountsViewModel {
    return ClientBankAccountsViewModelFromJSONTyped(json, false);
}

export function ClientBankAccountsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientBankAccountsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bankAccountsList': ((json['BankAccountsList'] as Array<any>).map(BankAccountDetailsFromJSON)),
    };
}

export function ClientBankAccountsViewModelToJSON(value?: ClientBankAccountsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'BankAccountsList': ((value.bankAccountsList as Array<any>).map(BankAccountDetailsToJSON)),
    };
}

